import { CostCode } from "../../domain/costCodes/costCode"
import { InvoicingSettings } from "../../domain/invoicing/settings/invoicingSettings"
import { Workarea } from "../../domain/job"

export type QboLinkingWarning = {
  type: 'customer' | 'costCode'
  costCodeId: number
}

export type QboLinkingWarningsParams = {
  invoicingSettings: InvoicingSettings | undefined
  isTenantConnectedToQuickBooks: boolean
  customerQboId: string | null | undefined
  workareas: Workarea[]
  costCodes: CostCode[]
}

export const getQboLinkingWarnings = ({ invoicingSettings, isTenantConnectedToQuickBooks, customerQboId, workareas, costCodes }: QboLinkingWarningsParams): QboLinkingWarning[] => {
  if (invoicingSettings?.invoicingSystem === 'synkedUp' && !isTenantConnectedToQuickBooks) {
    return []
  }

  const warnings: QboLinkingWarning[] = []

  if (!customerQboId) {
    warnings.push({ type: 'customer', costCodeId: 0 })
  }

  const costCodeIds = new Set(workareas.filter(x => x.isApproved).map(x => x.costCodeId))
  costCodeIds.forEach(costCodeId => {
    const costCode = costCodes.find(y => y.id === costCodeId)
    if (costCode && !costCode.qboId) {
      warnings.push({ type: 'costCode', costCodeId: costCode.id })
    }
  })

  return warnings
}
